import {
  useNotify,
  Toolbar,
  SaveButton,
  DeleteWithConfirmButton,
} from "react-admin";

type Props = {
  onDelete?: () => void;
  withDeleteButton?: boolean;
};

export const CampaignTdsFormToolbar = ({
  onDelete,
  withDeleteButton,
}: Props) => {
  const notify = useNotify();

  return (
    <Toolbar
      sx={{
        justifyContent: "space-between",
      }}
    >
      <SaveButton alwaysEnable />
      {withDeleteButton && (
        <DeleteWithConfirmButton
          confirmTitle="Delete campaign TDS #%{id}"
          successMessage="Campaign TDS deleted successfully"
          confirmContent="Are you sure you want to delete this campaign TDS?"
          mutationOptions={{
            onSuccess: () => {
              onDelete?.();
              notify("Campaign TDS successfully deleted!");
            },
          }}
        />
      )}
    </Toolbar>
  );
};
